"use strict";

var _interopRequireDefault = require("/home/sahil-meshram/Documents/Eiosys/BFP-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _index = require("@/utils/index");
var _index2 = _interopRequireDefault(require("@/components/Enabled/index.vue"));
var _clientsContacts = require("@/api/clients-contacts");
var _ClientsContactDetails = _interopRequireDefault(require("../../clients-contacts/components/ClientsContactDetails.vue"));
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.clientContactList = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.isEdit = false;
    this.dialogVisible = false;
    this.contactId = 0;
    this.listQuery = {
      page: 1,
      limit: 10,
      name: undefined,
      clientId: this.formData.id,
      sort: 'id,ASC',
      filter: {
        name: '$contL',
        clientId: '$eq'
      }
    };
  }
  created() {
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await (0, _clientsContacts.getClientsContacts)((0, _index.getQuery)(this.listQuery));
      for (const contact of data.data) {
        var _contact$emailAddress, _contact$fullName, _contact$mobileNumber;
        if ((_contact$emailAddress = contact.emailAddress) !== null && _contact$emailAddress !== void 0 && _contact$emailAddress.length) {
          contact.emailAddress = this.maskSensitiveInfo(contact.emailAddress);
        }
        if ((_contact$fullName = contact.fullName) !== null && _contact$fullName !== void 0 && _contact$fullName.length) {
          contact.fullName = this.maskSensitiveInfo(contact.fullName);
        }
        if ((_contact$mobileNumber = contact.mobileNumber) !== null && _contact$mobileNumber !== void 0 && _contact$mobileNumber.length) {
          contact.mobileNumber = this.maskSensitiveInfo(contact.mobileNumber);
        }
      }
      this.clientContactList = data.data;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  maskSensitiveInfo(input) {
    if (input.includes('@')) {
      // If it's an email
      const atIndex = input.indexOf('@');
      return input.slice(0, atIndex - 3) + '*' + input.slice(atIndex);
    } else if (input.match(/^\d+$/)) {
      // If it's a mobile number
      return input.slice(0, -4).replace(/\d/g, '*') + input.slice(-4);
    } else {
      // Otherwise, assuming it's a full name
      const nameParts = input.split(' ');
      return nameParts.map((part, index) => index === 0 ? part : '*'.repeat(part.length)).join(' ');
    }
  }
  async togglePrimary(contact) {
    // mark all contact as secondary
    const res = await (0, _clientsContacts.setPrimary)({
      contactId: contact.id,
      clientId: contact.clientId
    });
    if (res && res.status === 'success') {
      this.$notify({
        type: 'success',
        title: 'Success',
        message: res.message
      });
      this.getList();
    }
  }
  toogleDialog(action = 'add', contactId = 0) {
    this.contactId = contactId;
    switch (action) {
      case 'add':
        this.dialogVisible = true;
        this.isEdit = false;
        this.$nextTick(() => {
          const formRef = this.$refs.contactFormRef;
        });
        break;
      case 'edit':
        this.dialogVisible = true;
        this.isEdit = true;
        this.$nextTick(() => {
          const formRef = this.$refs.contactFormRef;
          // fetch contact detail
          formRef.fetchData(contactId);
        });
        break;
      default:
        this.dialogVisible = false;
        this.isEdit = false;
        break;
    }
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: {}
})], default_1.prototype, "formData", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ClientContactTab',
  components: {
    Enabled: _index2.default,
    ClientsContactDetail: _ClientsContactDetails.default
  }
})], default_1);
var _default = exports.default = default_1;